import { buildApiUrl, apiRequest } from '../config/api.js'

export const teamsApi = {
  async getTeams() {
    const url = buildApiUrl('/teams')
    return apiRequest(url)
  },

  async getTeam(teamId) {
    const url = buildApiUrl(`/teams/${teamId}`)
    return apiRequest(url)
  },

  async createTeam(teamData) {
    const url = buildApiUrl('/teams')
    return apiRequest(url, {
      method: 'POST',
      body: JSON.stringify({ team: teamData })
    })
  },

  async updateTeam(teamId, teamData) {
    const url = buildApiUrl(`/teams/${teamId}`)
    return apiRequest(url, {
      method: 'PUT',
      body: JSON.stringify({ team: teamData })
    })
  },

  async getTeamMembers(teamId) {
    const url = buildApiUrl(`/teams/${teamId}/members`)
    return apiRequest(url)
  },

  async addUserToTeam(teamId, userId) {
    const url = buildApiUrl(`/teams/${teamId}/users/${userId}`)
    return apiRequest(url, {
      method: 'POST'
    })
  },

  async removeUserFromTeam(teamId, userId) {
    const url = buildApiUrl(`/teams/${teamId}/users/${userId}`)
    return apiRequest(url, {
      method: 'DELETE'
    })
  },

  async deleteTeam(teamId) {
    const url = buildApiUrl(`/teams/${teamId}`)
    return apiRequest(url, {
      method: 'DELETE'
    })
  }
}
